/*** IMPORTS FROM imports-loader ***/
var define = false;

import Glide from 'glide.esm'
import {gsap} from "gsap";
//import {ScrollTrigger} from "gsap/ScrollTrigger";
//import {ScrollToPlugin} from "gsap/ScrollToPlugin";
//import LazyLoad from 'vanilla-lazyload/dist/lazyload.min'
//gsap.registerPlugin(LazyLoad);

let imagesLoaded = require('imagesloaded');
let navbar = null;
let nav = null;
let isMobile = false;
let initS = false

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    //console.log(rect);
    return (
        rect.top >= 0 - element.getBoundingClientRect().height &&
        rect.bottom <= element.getBoundingClientRect().height + (window.innerHeight || document.documentElement.clientHeight)
    );
}

function targetBlank() {
    // remove subdomain of current site's url and setup regex
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");

    var a = document.getElementsByTagName('a'); // then, grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of each link
        if (!internal.test(href) || /\.pdf$/.test(a[i].getAttribute("href"))) { // make sure the href doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
        }
    }
}

function initScripts() {
    "use strict";

    console.log('JS loaded');

    if (window.innerWidth < 568) {
        isMobile = true;
        //nav.classList.add("shrink");
    }

    targetBlank()
    // Mobile toggler
    document.querySelectorAll("button.navbar-toggler")[0].addEventListener("click", function (event) {
        let target = document.querySelectorAll('.navbar-collapse')[0];
        if (!this.classList.contains('open')) {
            $(this).addClass('open');
            $(target).addClass('show');
            $(navbar).addClass('open');
            $('html').addClass('disable-scroll');
        } else {
            $(this).removeClass('open');
            $(target).removeClass('show');
            $(navbar).removeClass('open');
            $('html').removeClass('disable-scroll');
        }
    });

    // parallaxContainer on mousemove
    document.querySelectorAll(".parallax-container").forEach((parallaxContainer) => {
        var parallaxItems = parallaxContainer.getElementsByClassName('parallax');
        var fixer = 0.0030;
        document.addEventListener("mousemove", function (event) {
            if (isInViewport(parallaxContainer)) {
                var pageX = event.pageX - (parallaxContainer.getBoundingClientRect().width * 0.5);
                var pageY = event.pageY - (parallaxContainer.getBoundingClientRect().height * 0.5);
                for (var $i = 0; $i < parallaxItems.length; $i++) {
                    var item = parallaxItems[$i];
                    var speedX = item.getAttribute("data-speed-x");
                    var speedY = item.getAttribute("data-speed-y");
                    gsap.set(item, {
                        x: (item.offsetLeft + pageX * speedX) * fixer,
                        y: (item.offsetTop + pageY * speedY) * fixer
                    });
                }
            }
        });
    });


    //year nav
    let nav2 = document.getElementsByClassName('year-item');
    let j;

    for (j = 0; j < nav2.length; j++) {
        nav2[j].addEventListener('click', function () {
            $('.year-item').removeClass('active');
            $('.year-items ').hide();
            $('.items-' + $(this).data('year')).fadeIn();
            this.classList.toggle('active');
        });
    }

    //more btns
    let btns = document.getElementsByClassName('btn-more');
    let z;

    for (z = 0; z < btns.length; z++) {
        btns[z].addEventListener('click', function () {
            $('.items-' + $(this).data('year') + ' .grid-item').fadeIn();
            this.classList.add('isHidden');
        });
    }
    // accordion
    let acc = document.getElementsByClassName('accordion');
    let i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function () {
            this.classList.toggle('active');
            let panel = this.nextElementSibling;
            let parent = $(this).closest('.panel-big');
            console.log(parent[0])

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
                if (parent.length > 0)
                    $(parent[0]).css('maxHeight', 'none');
            }
        });
    }

    // checkbox produkt
    let select = document.querySelectorAll('.produkte select');
    let i2;

   /* for (i2 = 0; i2 < check.length; i2++) {
        check[i2].addEventListener('change', function () {

            if (this.checked) {
                $(this).parent().parent().parent().find('.select-item').addClass('show')
            } else {
                $(this).parent().parent().parent().find('.select-item').removeClass('show')
            }
        });
    }*/
    if (document.querySelector(".btn-order")) {
        document.querySelector(".btn-order").addEventListener("click", function (event) {
            let send = false
            for (i2 = 0; i2 < select.length; i2++) {
                console.log(select[i2].value);
                if(select[i2].value !== "0")
                    send = true

            }
            if(!send) {
                event.preventDefault()
                alert('Bitte mindestens 1 Produkt wählen!')
            }
        })
    }


    if (document.querySelectorAll(".glide-years").length > 0) {
        let glide = document.querySelector('.glide-years');
        new Glide(glide, {gap: 0, autoplay: 0}).mount()
    }

    if (document.querySelectorAll(".glide-signs").length > 0) {
        let glide = document.querySelector('.glide-signs');
        new Glide(glide, {
            gap: 24, autoplay: 0, perView: 2, breakpoints: {
                1000: {
                    perView: 1
                }
            }
        }).mount()
    }
    if (document.querySelectorAll(".glide-quotes").length > 0) {
        let glide = document.querySelector('.glide-quotes');
        new Glide(glide, {gap: 24, autoplay: 0}).mount()
    }

    if (document.querySelectorAll(".gallery .glide").length > 0) {
        document.querySelectorAll(".gallery").forEach((gallery) => {
            let glide = gallery.querySelector('.glide');
            new Glide(glide, {autoplay: 0}).mount()
        });
    }

    // Preload Images
    // TODO: replace with better lazy loading
    imagesLoaded(document.querySelector("body"), function (instance) {
        // fadein main
        var tlinit = gsap.timeline({
            onComplete: function () {
                //console.log('complete');
                $('.loader').hide();
                tlinit.play();
            }
        });

        tlinit.to('.loader', {
            opacity: 0,
            duration: 0.050
        }, '+=0');

        tlinit.to('.navbar', {
            opacity: 1,
            duration: 0.250
        }, '+=0');

        tlinit.to('.banner', {
            opacity: 1,
            duration: 0.250
        }, '+=0.10');
        tlinit.to('main', {
            opacity: 1,
            duration: 0.550
        }, '+=0');
    });

    // LazyLoader for videos
    let VideoContainers = document.querySelectorAll(".embed-video");
    let imageSource = '';

    // Iterate over every YouTube container you may have
    for (let i = 0; i < VideoContainers.length; i++) {
        let container = VideoContainers[i];
        if (container.dataset.videoType == 'youtube') {
            imageSource = (container.dataset.posterImg !== '') ? container.dataset.posterImg : "https://ff-23134-hoeren-website.btqa.de/posterimage.php?vid=" + container.dataset.videoId + "&p=youtube";
        }

        // Load the Thumbnail Image asynchronously
        let image = new Image();
        image.src = imageSource;
        image.alt = 'Youtube Posterimage';
        image.addEventListener("load", function () {
            container.appendChild(image);
        });

        // When the user clicks on the container, load the embedded video
        container.addEventListener("click", function () {
            let iframe = document.createElement("iframe");

            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("title", container.dataset.title);
            iframe.setAttribute("aria-label", container.dataset.label);
            iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
            // Important: add the autoplay GET parameter, otherwise the user would need to click over the YouTube video again to play it
            if (this.dataset.videoType == 'youtube') {
                iframe.setAttribute("src", "https://www.youtube-nocookie.com/embed/" + this.dataset.videoId + "?rel=0&showinfo=0&autoplay=1");
            }
            // Clear Thumbnail and load the YouTube iframe
            this.innerHTML = "";
            this.appendChild(iframe);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    navbar = document.querySelector('.navbar');
    nav = document.getElementById("mainNav");
    console.log('JS DOMContentLoaded');
    if (!initS) {
        initScripts();
        initS = true
    }
    // navbar shrink
    window.addEventListener("scroll", function () {
        if (window.scrollY > 100) {
            nav.classList.add("shrink");
        } else {
            nav.classList.remove("shrink");
        }
    });
}, { once: true });

